import { ca } from '@cian/analytics';

export function trackFullscreenShow(isFullscreen: boolean, objectType?: string) {
  ca('eventSite', {
    action: 'fullscreen',
    category: 'Infrastructure',
    label: isFullscreen ? 'show_sopr' : 'close_show_sopr',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        PageTypeJK: 'Normal',
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
